export default __webpack_public_path__ + "static/media/faq.37ffaace.png";